import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";

const PageId = 13;
const BackPageId = PageId - 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);

  useEffect(() => {
    if (PageId === currentPage) setTimeout(() => setStep(1), 400);
    else setStep(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  useEffect(() => {
    if (step >= 1 && step < 7) setTimeout(() => setStep((prev) => prev + 1), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  const title = "The B2B Value Proposition –\nInfosys Entertainment Platform";

  const description =
    "The Infosys Entertainment Platform empowers service providers with cost-effective, scalable, and flexible solutions to drive\ngrowth and enhance user satisfaction.";

  const animation_0 = `${baseImages}animation_0.png`;
  const animation_1 = `${baseImages}animation_1.png`;
  const animation_2 = `${baseImages}animation_2.png`;
  const animation_3 = `${baseImages}animation_3.png`;
  const animation_4 = `${baseImages}animation_4.png`;

  const rightSideComponentStyle: React.CSSProperties = {
    position: "absolute",
    top: 0,
    right: 0,
    transition: "opacity .6s ease-in-out",
    height: "100%",
    width: "100%",
  };

  return {
    bgImage: `${baseImageBG}BG_3.jpg`,
    title,
    description,
    rightSideComponent: (
      <>
        <img src={animation_0} alt="" style={{ ...rightSideComponentStyle, opacity: step >= 1 ? 1 : 0 }} />
        <img src={animation_1} alt="" style={{ ...rightSideComponentStyle, opacity: step >= 2 ? 1 : 0 }} />
        <img src={animation_2} alt="" style={{ ...rightSideComponentStyle, opacity: step >= 3 ? 1 : 0 }} />
        <img src={animation_3} alt="" style={{ ...rightSideComponentStyle, opacity: step >= 4 ? 1 : 0 }} />
        <img src={animation_4} alt="" style={{ ...rightSideComponentStyle, opacity: step >= 5 ? 1 : 0 }} />
      </>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: { gap: "var(--width-16)" },
    },
    next: {
      label: "Finish",
      type: "next",
      onClick: () => setCurrentPage(1),
      style: { gap: "var(--width-16)" },
    },
  };
};

export default DATA;
